var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"mx-2 mt-1",staticStyle:{"font-size":"1.5rem","color":"#232323","font-family":"'Sawarabi Gothic'"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }